import React from 'react';
import PropTypes from 'prop-types';

/**
 * FormRow — label + children + error message layout wrapper.
 *
 * Props:
 *   label    – field label text
 *   required – shows red asterisk
 *   error    – validation error message
 *   children – field input(s)
 */
const FormRow = ({ label, required = false, error, children }) => (
  <div className="tw-mb-4">
    {label && (
      <label className="tw-block tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-1.5">
        {label}
        {required && <span className="tw-text-red-500 tw-ml-0.5">*</span>}
      </label>
    )}
    {children}
    {error && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{error}</p>}
  </div>
);

FormRow.propTypes = {
  label:    PropTypes.string,
  required: PropTypes.bool,
  error:    PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default FormRow;
